import Utils from './utils'

const props = {
  props: {
    iconProvider: {
      type: String,
      default: 'mdi',
      validator: value => {
        return ['mdi', 'fa', 'google'].includes(value)
      }
    },
    iconColorLightness: {
      type: [Number, String],
      validator: value => {
        const utils = new Utils()
        return utils.validateLightness(value)
      }
    },
    labelColorLightness: {
      type: [Number, String],
      default: null,
      validator: value => {
        const utils = new Utils()
        return utils.validateLightness(value)
      }
    },
    colorLightness: {
      type: [Number, String],
      default () {
        const node = this.$vnode.tag.split('-').pop()
        switch (node) {
          case 'BottomNavigation':
          case 'Pager':
            return 600
          case 'Alert':
            return null
          default:
            return null
        }
      },
      validator: value => {
        const utils = new Utils()
        return utils.validateLightness(value)
      }
    },
    bgColorLightness: {
      type: [Number, String],
      default () {
        const node = this.$vnode.tag.split('-').pop()
        switch (node) {
          case 'Toolbar':
          case 'Btn':
          case 'Chip':
          case 'CardTitle':
          case 'Fab':
          case 'Tab':
          case 'Switcher':
            return 300
          case 'BottomNavigation':
          case 'BottomSheets':
          case 'Card':
          case 'Collapsible':
          case 'DialogBox':
            return null
          case 'Snackbar':
            return 800
          default:
            return 500
        }
      },
      validator: value => {
        const utils = new Utils()
        return utils.validateLightness(value)
      }
    },
    elevation: {
      type: String,
      default () {
        const node = this.$vnode.tag.split('-').pop()
        switch (node) {
          case 'FormGroup':
          case 'Progressbar':
            return 'none'
          case 'Navbar':
          case 'MenuList':
          case 'Dropdown':
          case 'Autocomplete':
          case 'TimePickerField':
            return 'xl'
          case 'DialogBox':
          case 'ContextMenu':
            return '2xl'
          case 'SystemBar':
          case 'SkeletonLoader':
            return 'none'
          default:
            return 'md'
        }
      },
      validator: value => {
        return ['sm', 'md', 'lg', 'xl', '2xl', 'inner', 'none'].includes(value)
      }
    }
  }
}

export default props



// WEBPACK FOOTER //
// ./src/bcq-ui/mixins/props.js